import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Menu, X } from 'lucide-react';

export const Nav = () => {
    const { user, logout, loginWithGoogle } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);

    const links = [
        { to: '/', label: 'Accueil' },
        { to: '/#services', label: 'Services' },
        { to: '/reservation', label: 'Réservation' },
        { to: '/#contact', label: 'Contact' },
    ];

    const handleLink = (to) => {
        setOpen(false);
        if (to.startsWith('/#')) {
            if (location.pathname !== '/') navigate('/');
            setTimeout(() => {
                const el = document.querySelector(to.substring(1));
                el?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else {
            navigate(to);
        }
    };

    return (
        <nav data-testid="main-nav" className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-xl border-b border-white/5">
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <Link to="/" data-testid="brand-link" className="font-display text-xl tracking-wider text-[#F8F8F5]">
                    ARNOUX <span className="text-[#C5A059]">&amp;</span> CO <span className="text-[#A3A39D] text-sm tracking-widest">TAXI</span>
                </Link>

                <div className="hidden md:flex items-center gap-10">
                    {links.map(l => (
                        <button
                            key={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            onClick={() => handleLink(l.to)}
                            className="text-xs uppercase tracking-[0.25em] text-[#A3A39D] hover:text-[#C5A059] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </div>

                <div className="hidden md:flex items-center gap-4">
                    {user ? (
                        <>
                            <button
                                data-testid="nav-account-btn"
                                onClick={() => navigate(user.role === 'admin' ? '/admin' : '/mon-compte')}
                                className="text-xs uppercase tracking-[0.25em] text-[#F8F8F5] hover:text-[#C5A059] transition-colors"
                            >
                                {user.role === 'admin' ? 'Admin' : 'Mon compte'}
                            </button>
                            <button
                                data-testid="nav-logout-btn"
                                onClick={logout}
                                className="text-xs uppercase tracking-[0.25em] text-[#A3A39D] hover:text-[#C5A059] transition-colors"
                            >
                                Déconnexion
                            </button>
                        </>
                    ) : (
                        <button
                            data-testid="nav-login-btn"
                            onClick={loginWithGoogle}
                            className="text-xs uppercase tracking-[0.25em] text-[#F8F8F5] hover:text-[#C5A059] transition-colors"
                        >
                            Connexion
                        </button>
                    )}
                    <button
                        data-testid="nav-book-btn"
                        onClick={() => navigate('/reservation')}
                        className="bg-[#C5A059] text-black px-6 py-3 text-xs uppercase tracking-[0.25em] font-medium hover:bg-[#DCC283] transition-colors"
                    >
                        Réserver
                    </button>
                </div>

                <button data-testid="nav-mobile-toggle" className="md:hidden text-[#F8F8F5]" onClick={() => setOpen(!open)}>
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-black border-t border-white/5 px-6 py-6 space-y-4">
                    {links.map(l => (
                        <button key={l.to} onClick={() => handleLink(l.to)}
                            className="block text-xs uppercase tracking-[0.25em] text-[#A3A39D] hover:text-[#C5A059]">
                            {l.label}
                        </button>
                    ))}
                    {user ? (
                        <>
                            <button onClick={() => { setOpen(false); navigate(user.role === 'admin' ? '/admin' : '/mon-compte'); }} className="block text-xs uppercase tracking-[0.25em]">
                                {user.role === 'admin' ? 'Admin' : 'Mon compte'}
                            </button>
                            <button onClick={() => { logout(); setOpen(false); }} className="block text-xs uppercase tracking-[0.25em] text-[#A3A39D]">
                                Déconnexion
                            </button>
                        </>
                    ) : (
                        <button onClick={() => { setOpen(false); loginWithGoogle(); }} className="block text-xs uppercase tracking-[0.25em]">
                            Connexion
                        </button>
                    )}
                    <button onClick={() => { setOpen(false); navigate('/reservation'); }}
                        className="block bg-[#C5A059] text-black px-6 py-3 text-xs uppercase tracking-[0.25em]">
                        Réserver
                    </button>
                </div>
            )}
        </nav>
    );
};
